import { compose, pure, withHandlers, withState } from "recompose";

import CreateCategorySideModal from "./CreateCategorySideModal";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import React from "react";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import _ from "lodash";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

const sideModalVisible = withState(
  "sideModalVisible",
  "setSideModalVisible",
  false
);

const inputCategory = withState("inputCategory", "setInputCategory", {});

const handlers = withHandlers({
  createCategory: ({
    companyId,
    createCategoryMutation,
    setSideModalVisible,
    value,
    onSelected,
    getCategories,
    getCompanySettings
    //getActiveCategories
  }) => async (companyId, categoryName, categoriesParent, category) => {
    //console.log("===createCategoryMutation===");
    //console.log("companyId =", companyId);
    //console.log("categoryName =", categoryName);
    //console.log("categoriesParent =", categoriesParent);
    //console.log("category =", category);

    const variables = {
      companyId: companyId,
      categoryName,
      categoriesParentId: categoriesParent.element.id,
      lettrageAuto: categoriesParent.element.lettrageAuto,
      fluxTresorerie: categoriesParent.element.fluxTresorerie,
      auxiliarisable: categoriesParent.element.auxiliarisable,
      sensHabituel: categoriesParent.element.sensHabituel,
      categoryFamilyId: categoriesParent.element.categoryFamily.id,
      accountId: categoriesParent.element.account.id
    };

    const mutation = await createCategoryMutation({
      variables
    });

    console.log("createCategoryMutation=", mutation);

    await getCategories.refetch();
    await getCompanySettings.refetch();
    //await getActiveCategories.refetch();

    const categories = mutation.data.updateCompany.categories;
    const newCategory = {
      value: categories[categories.length - 1].id,
      label: categories[categories.length - 1].name,
      element: categories[categories.length - 1]
    };
    onSelected(newCategory);
    setSideModalVisible(false);
  }
});

const data = graphql(Queries.getCategories, {
  name: "getCategories",
  // variables: {
  //   companyId: ""
  // },
  options: {
    fetchPolicy: "cache-and-network"
  },
  props: ({
    getCategories,
    getCategories: { refetch },
    expenseCategory,
    supplierCategory,
    collaboratorCategory,
    invoiceCategory,
    clientCategory,
    tiersCategory,
    tiers
    //companyId,
    //companyId2
  }) => {
    // console.log("Queries.getCategories", companyId, companyId2); //, companyId);
    return {
      refetch,
      getCategories,
      expenseCategory,
      supplierCategory,
      collaboratorCategory,
      invoiceCategory,
      clientCategory,
      tiersCategory,
      tiers
      //companyId
    };
  }
});

const dataActiveCategories = graphql(Queries.getCompanySettings, {
  name: "getCompanySettings",
  options: ({ companyId }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        companyId,
        active: true
      }
    };
  }
});

let CategorySelect = ({
  value,
  creatable,
  refetch,
  onSelected,
  getCategories,
  getCompanySettings,
  sideModalVisible,
  inputCategory,
  setSideModalVisible,
  setInputCategory,
  sendNotification,
  currencyId,
  createCategory,
  setIsEdit,
  disabled,
  companyId, /// always undefined here ! weird
  companyId2,
  onlyGenericCategory,
  collaboratorLimitation,
  intl
}) => {
  let onlyActiveCategories = true; // ? Maybe should param this.

  //console.log("CategorySelect companyId", companyId, companyId2);
  // console.log("146 - getCategories value", getCategories);

  let u = _.uniqBy(
    _.union(
      getCategories.tierses,
      getCategories.tiers,
      getCategories.expense,
      getCategories.supplier,
      getCategories.client,
      getCategories.collaborator,
      getCategories.invoice
    ),
    "id"
  );

  // console.log("161 - u value", u);
  if (collaboratorLimitation === true) {    
    // u = _.filter(u, o => {
    //   return o.categoryFamily && 
    //   (
    //     o.categoryFamily.ids === "ids_fraisProfessionnelsDeplacement" ||
    //     // o.categoryFamily.ids === "ids_fraisBancairesAgios" ||
    //     // o.categoryFamily.ids === "ids_publicite" ||
    //     // o.categoryFamily.ids === "ids_telephoneFibreAdslInternet" ||
    //     // o.categoryFamily.ids === "ids_transportsColis" ||
    //     // o.categoryFamily.ids === "ids_loyerLocationsLeasing" || 
    //     o.categoryFamily.ids === "ids_achatsEtSousTraitance" 
    //   )
    // });

    u = _.filter(u, o => {
      return (
        o.ids === "ids_fraisDeDeplacement" ||        
        o.ids === "ids_achatsMarchandises" 
      )
    });

    
  }

  // console.log("CategorySelect value", u);
  // console.log("getCompanySettings", getCompanySettings);
  let mapActiveCategories = new Map();

  if (getCompanySettings && getCompanySettings.companyCategorySettings) {
    _.forEach(getCompanySettings.companyCategorySettings, (value, key) => {
      if (value.category)
        mapActiveCategories.set(value.category.id, 1);
    });
  }

  // TRANSLATIONS.....
  _.forEach(u, o => {
    if (o.ids !== null) {
      o.name = intl.formatMessage({ id: o.ids });
    }
    if (o.categoryFamily && o.categoryFamily.ids !== null) {
      o.categoryFamily.name = intl.formatMessage({ id: o.categoryFamily.ids });
    }
  });

  let res = _.groupBy(u, o => {
    if (
      o.categoryFamily.ids === "ids_clients" ||
      o.categoryFamily.ids === "ids_suppliers" ||
      o.categoryFamily.ids === "ids_collaborators"
    )
      return intl.formatMessage({ id: "ids_reglements" });

    return o.categoryFamily.name;
  });

  let options = [];
  // let mapTitle = new Map();

  // group title in selection list only when there are at least two groups
  let isTitle = Object.keys(res).length > 1;
  _.forEach(res, (value, key) => {
    if (onlyGenericCategory) {
      let linesToRemove = [];

      // Check Company Id. If not null, not generic category
      _.forEach(value, line => {
        if (line.company !== null) {
          linesToRemove.push(line);
        }
      });

      if (linesToRemove.length > 0) {
        _.forEach(linesToRemove, line => {
          let index = value.indexOf(line);
          value.splice(index, 1);
        });
      }
    }

    if (onlyActiveCategories) {
      let linesToRemove = [];

      // Check Company Id. If not null, not generic category
      _.forEach(value, line => {
        if (mapActiveCategories.get(line.id) !== 1) {
          linesToRemove.push(line);
        }
      });

      if (linesToRemove.length > 0) {
        _.forEach(linesToRemove, line => {
          let index = value.indexOf(line);
          value.splice(index, 1);
        });
      }
    }

    if (isTitle) {
      let option = {
        label: key,
        options: value.map(category => {
          return {
            label: category.name,
            value: category.id,
            element: category
          };
        })
      };
      options.push(option);
    } else {
      options = value.map(category => {
        return {
          label: category.name,
          value: category.id,
          element: category
        };
      });
    }

    // value.map(category => {
    //   mapTitle.set( category.id,  category.name);
    // });    
  });

  if (options.length === 2) {
    options.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  }

  return (
    <div>
      <SimpleSelect
        creatable={creatable}
        name="clientOrProject"
        value={value}
        onSelected={onSelected}
        options={options}
        onNewOptionClick={category => {
          setInputCategory(category.value);
          setSideModalVisible(true);
        }}
        disabled={disabled}
      />
      {sideModalVisible ? (
        <FormattedMessage id="ids_registerNewCategory">
          {title => (
            <CreateCategorySideModal
              title={title}
              sendNotification={sendNotification}
              inputCategory={inputCategory}
              sideModalVisible={true}
              setSideModalVisible={setSideModalVisible}
              setIsEdit={setIsEdit}
              companyId={companyId}
              currencyId={currencyId}
              createCategory={createCategory}
            />
          )}
        </FormattedMessage>
      ) : (
        <div />
      )}
    </div>
  );
};

export default compose(
  data,
  dataActiveCategories,
  graphql(Queries.createCategory, { name: "createCategoryMutation" }),
  sideModalVisible,
  inputCategory,
  handlers,
  injectIntl,
  pure
)(CategorySelect);
